/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import api from "api";
import { useLoading, handleLoading } from "context/LoadingContext";
import { useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { useAuth } from "context/auth";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function ValidateOwnership(props) {
  const { data, toggleDialog } = props;
  const [auth] = useAuth();
  const [, dispatchLoading] = useLoading();
  const navigate = useNavigate();
  const handleGettingPaymentNumber = async () => {    
    try {
      handleLoading(dispatchLoading, true);
      await api.put("payment/new", {
        dlsKey: data?.DLS_KEY,
        zoneCodeArray: [data?.code],
        phoneNumber: auth.userDetails.details.phoneNumber,
        parcelId: data?.PARCEL_ID,
        hodCode: data?.HOD_CODE,
      });
      NotificationManager.success(
        "يمكنك طباعة المخطط المطلوب من شاشة طلباتي بعد الدفع المبلغ المستحق"
      );
      navigate("/requests");
      toggleDialog();
    } catch (error) {
      ErrorHandelFunctionApp(error);
      let CheckError=error?.response?.data?.errorCode;

      if(CheckError=="PaymentNew_AlreadyExist_Paid"||CheckError=="PaymentNew_AlreadyExist_NotPaid"){
        const queryParams = new URLSearchParams({
          Query: error?.response?.data?.data?.ePaymentNumber,
        }).toString();
        navigate(`/requests?${queryParams}`);
      }      
    }
    handleLoading(dispatchLoading, false);
  };
  return (
    <div className="validate_ownership">
      <div className="validate_ownership__container">
        <ul className="validate_ownership__data list-unstyled">
          <li>
            <span className="validate_ownership__data__title">
              <span>رقم القطعة</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.PARCEL_ID}
            </span>
          </li>
          <li>
            <span className="validate_ownership__data__title">
              <span>صفة الاستعمال</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.usage}
            </span>
          </li>
          <li>
            <span className="validate_ownership__data__title">
              <span>المساحة</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.area} م
            </span>
          </li>
          <li>
            <span className="validate_ownership__data__title">
              <span>رقم الحوض</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.HOD_CODE}
            </span>
          </li>
          <li>
            <span className="validate_ownership__data__title">
              <span>اسم المنطقة</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.VILL_ANAME}
            </span>
          </li>
          <li>
            <span className="validate_ownership__data__title">
              <span>قيمة الدفع</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.price} د
            </span>
          </li>
          <li>
            <span className="validate_ownership__data__title">
              <span>DLS_KEY</span> <span>:</span>
            </span>
            <span className="validate_ownership__data__value">
              {data?.DLS_KEY}
            </span>
          </li>
        </ul>
        <div className="validate_ownership__data">
          <img
            src={`${process.env.PUBLIC_URL}/form-placeholder.svg`}
            alt="form-placeholder"
          />
        </div>
      </div>
      <div className="validate_ownership__actions d-grid">
        <button
          type="button"
          className="btn btn--primary w-100 mt-4"
          onClick={handleGettingPaymentNumber}
        >
          طلب رقم دفع الكتروني
        </button>
      </div>
    </div>
  );
}
ValidateOwnership.defaultProps = {
  data: {},
  toggleDialog: () => {},
};
ValidateOwnership.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  toggleDialog: PropTypes.func,
};
export default ValidateOwnership;
